/* global GLightbox:false */

const lightbox = GLightbox({
	touchNavigation: true,
	loop: true,
});
